import { FC, Fragment } from 'react';

import { VisuallyHidden } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { info } from '@purpur/library/icon/assets/info';

import { Feature } from '@telialt/models/src/EshopModel';
import { useComponentId } from '@telialt/utils/src/hooks';

import { CharacteristicsFeatureValue } from './CharacteristicsFeatureValue';
import { CharacteristicsFeatureValueSeparator } from './CharacteristicsFeatureValueSeparator';
import { TechnicalCharacteristicsAlignment } from './model';
import { Container, KeyColumn, TitleColumn, TooltipPointer, ValueColumn } from './TechnicalCharacteristics.styles';

type Props = {
    title: string;
    features: Feature[];
    alignment?: TechnicalCharacteristicsAlignment;
};

export const TechnicalCharacteristicsGroup: FC<Props> = ({ title, features, alignment }) => {
    const titleId = useComponentId(`group-title`);

    return (
        <>
            <VisuallyHidden id={titleId}>{title}</VisuallyHidden>
            <Container $alignment={alignment} aria-labelledby={titleId}>
                <TitleColumn aria-hidden={true} $alignment={alignment} $rows={features.length}>
                    {title}
                </TitleColumn>
                {features.map((feature) => (
                    <Fragment key={feature.code}>
                        <KeyColumn $alignment={alignment}>
                            {feature.name}
                            {feature.labelDescription && (
                                <TooltipPointer
                                    content={feature.labelDescription}
                                    id={`technical-characteristics-tooltip-content-${feature.code.replace(/\W/g, '-')}`}
                                >
                                    <Icon svg={info} size="sm" allyTitle="informacija" />
                                </TooltipPointer>
                            )}
                        </KeyColumn>
                        <ValueColumn $alignment={alignment}>
                            {feature.featureValues.map(({ value }, index) => {
                                const isLast = feature.featureValues.length === index - 1;

                                return (
                                    <Fragment key={index}>
                                        <CharacteristicsFeatureValue featureValue={value} />
                                        <CharacteristicsFeatureValueSeparator feature={feature} isLast={isLast} />
                                    </Fragment>
                                );
                            })}
                        </ValueColumn>
                    </Fragment>
                ))}
            </Container>
        </>
    );
};
